import http from '../../../Utils/http';

const UpdateUsersPlan = {
  name: 'updateUsersPlan',
  state: {
    loading: false,
    error: '',
    message: '',
    updatedUserCount: 0,
  },
  reducers: {
    updatePlanRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        message: '',
        updatedUserCount: 0,
      };
    },
    updatePlanReceived(state, payload) {
      return {
        ...state,
        loading: false,
        message: payload.message,
        updatedUserCount: payload.updatedUserCount,
        error: '',
      };
    },
    updatePlanRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
        message: '',
      };
    },
  },
  effects: (dispatch) => ({
    async requestForUpdatePlan(data) {
      try {
        this.updatePlanRequested();
        const response = await http.post(`savvy/users/updatePlan`, data);
        this.updatePlanReceived(response.data);
        return response.data;
      } catch (err) {
        const errorMessage =
          err.response?.data?.error || 'Error in updating plan.';
        this.updatePlanRequestFailed(errorMessage);
        throw err;
      }
    },
    async clearData() {
      this.updatePlanReceived({ message: '', updatedUserCount: 0 });
    },
  }),
};

export default UpdateUsersPlan;
